import { createApiRef } from '@backstage/core-plugin-api';
import {
  Lock,
  CreateLockRequest,
  AffectedLocks,
  LockActionRequest,
} from './types';

export const lockManagerApiRef = createApiRef<LockManagerApi>({
  id: 'plugin.lock-manager.service',
});

export interface LockManagerApi {
  getLocks(): Promise<Lock[]>;
  createLock(request: CreateLockRequest): Promise<Lock>;
  lockLock(lockName: string, request?: LockActionRequest): Promise<Lock>;
  unlockLock(lockName: string, request?: LockActionRequest): Promise<Lock>;
  lockAll(request?: LockActionRequest): Promise<AffectedLocks>;
  unlockAll(request?: LockActionRequest): Promise<AffectedLocks>;
}
